const COLLECTION_STATUS_TYPES = {
  COMPLETE: {
    value: "complete",
    readableName: "Complete",
  },
  INCOMPLETE: {
    value: "incomplete",
    readableName: "Incomplete",
  },
};

// Convert the object to an array of entries
export const collectionStatusTypesArray = Object.values(COLLECTION_STATUS_TYPES);
